import { Modal, Form, Button } from "semantic-ui-react";

function SelecionaZonalModal({ zonais, onChangeZonal, isOpen, setIsOpen }) {
  const options = zonais.map((s) => ({
    key: s.codigoZonal,
    value: s.codigoZonal,
    text: s.nomeZonal,
  }));

  options.unshift({key: -1});

  const onChange = (e, data) => {
    if (data.value) {
      onChangeZonal(
        "zonal",
        zonais.filter((z) => z.codigoZonal === data.value)[0]
      );
    }
  };
  return (
    <Modal open={isOpen}>
      <Modal.Content>
        <p>Escolha o zonal mais próximo da sua residência.</p>
        <Form>
          <Form.Group  widths="equal">
            <Form.Select
              fluid
              search
              label="Zonal"
              name="zonal"
              id="zonal"
              onChange={onChange}
              options={options}
              required
            />
          </Form.Group>
        </Form>
        <Button onClick={() => setIsOpen(false)} primary>
          Confirmar
        </Button>
      </Modal.Content>
    </Modal>
  );
}

export default SelecionaZonalModal;
